<script lang="ts">

import type ChartRange from './ChartRange';
import { CHART_COLORS } from './ChartLayer';
import type { ChartColor } from './ChartLayer';

/**
 * VChartRanges — декларативный слой вертикальных отрезков VChart («было → стало» на дату). Сам ничего не рендерит.
 *
 * Отрезок без конца — одна засечка. Блеклость отрезка задаёт потребитель через ChartRange.isMuted.
 *
 * @example
 * <VChartRanges label="Тендеры" color="blue" :ranges="tenders"/>
 */
export default defineComponent({
  name: 'VChartRanges',

  props: {
    /** Подпись в легенде */
    label: {
      type:     String,
      required: true,
    },

    color: {
      type:      String as PropType<ChartColor>,
      required:  true,
      validator: (v: string) => (CHART_COLORS as readonly string[]).includes(v),
    },

    ranges: {
      type:     Array as PropType<ChartRange[]>,
      required: true,
    },
  },

  render() {
    return null;
  },
});
</script>
